export const EmailIcon: React.FC<any> = ({ className }) => {
   return (
      <div
         className={className}
         dangerouslySetInnerHTML={{
            __html: `
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="inherit"
        >
        <g clip-path="url(#clip0_207_700)">
            <path
                d="M11.875 0.625H3.125C2.2965 0.625992 1.50222 0.955551 0.916387 1.54139C0.330551 2.12722 0.000992411 2.9215 0 3.75L0 11.25C0.000992411 12.0785 0.330551 12.8728 0.916387 13.4586C1.50222 14.0445 2.2965 14.374 3.125 14.375H11.875C12.7035 14.374 13.4978 14.0445 14.0836 13.4586C14.6694 12.8728 14.999 12.0785 15 11.25V3.75C14.999 2.9215 14.6694 2.12722 14.0836 1.54139C13.4978 0.955551 12.7035 0.625992 11.875 0.625ZM3.125 1.875H11.875C12.2492 1.87574 12.6147 1.98845 12.9243 2.19863C13.234 2.40881 13.4737 2.70684 13.6125 3.05438L8.82625 7.84125C8.47402 8.19207 7.99713 8.38904 7.5 8.38904C7.00287 8.38904 6.52598 8.19207 6.17375 7.84125L1.3875 3.05438C1.52634 2.70684 1.76601 2.40881 2.07565 2.19863C2.3853 1.98845 2.75076 1.87574 3.125 1.875ZM11.875 13.125H3.125C2.62772 13.125 2.15081 12.9275 1.79917 12.5758C1.44754 12.2242 1.25 11.7473 1.25 11.25V4.6875L5.29 8.725C5.87664 9.31016 6.67141 9.63877 7.5 9.63877C8.32859 9.63877 9.12336 9.31016 9.71 8.725L13.75 4.6875V11.25C13.75 11.7473 13.5525 12.2242 13.2008 12.5758C12.8492 12.9275 12.3723 13.125 11.875 13.125Z"
                fill="inherit"
            />
        </g>
        <defs>
            <clipPath id="clip0_207_700">
                <rect width="15" height="15" fill="inherit" />
            </clipPath>
        </defs>
        </svg>
    `,
         }}
      />
   )
}
